export default {
  notification: {
    id: "Id",
    title: "Template Name",
    type: "Notification Type",
    newType: "Add Type",
    newTypeName: "Type Name",
    newTypeValue: "Type Value",
    newTypeGetField: "Get Field",
    getField: "Match property",
    receiver: "Recipient(s)",
    sender: "Sender",
    variable: "Variable(s)",
    template: "Template",
    note: "Note",
    chipMessage: "Dynamic Message",
    sendAt: "Sent At",
    readAt: "Read At",
    history: "Notifications List",
    allActivities: "See more...",
    markAsRead: "Mark As Read",
    cancel: "Cancel",
    is_read: "Is Read",
    status: "Status",
    active: "Active",
    sendToUsername: "Use {username} as additional recipient",
    description: "Description"
  }
};
